import { SettingsScreen } from '../features/console';

export function SettingsPage() {
  return <SettingsScreen />;
}
